import { Table, Tbody, Td, Thead, Tr, Text, Th } from "@chakra-ui/react";
import { BaseRate } from "@common/loans/base-rate/base-rate.model";
import { DataTableRowActions } from "components/elements/Datatable/data-table-row-actions";
import { DataTableRowSkeleton } from "components/elements/Datatable/data-table-row-skeleton";
import { ThActions } from "components/elements/Datatable/data-table-th-actions";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { useCustomFormats } from "hooks/useCustomFormat";

export function BaseRateTable() {
  const { formatDate } = useCustomFormats();
  const { data: result, isFetching, modal } = useResource<BaseRate>();

  const sortedResult = result?.data.sort((a, b) => {
    return new Date(b.effective_from).getTime() - new Date(a.effective_from).getTime();
  });

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Rate</Th>
          <Th>Effective From</Th>
          <Th>Effective To</Th>
          <ThActions />
        </Tr>
      </Thead>
      <Tbody>
        {isFetching ? (
          <DataTableRowSkeleton columns={4} rows={5} />
        ) : sortedResult?.length > 0 ? (
          sortedResult?.map(item => (
            <Tr key={item.id} onClick={() => modal.handleOpenModal(item)} cursor="pointer">
              <Td>{item.rate}%</Td>
              <Td>{formatDate(item.effective_from)}</Td>
              <Td>{item.effective_to ? formatDate(item.effective_to) : "Current"}</Td>
              <Td onClick={e => e.stopPropagation()}>
                <DataTableRowActions item={item} />
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={4} textAlign="center">
              <Text p={4}>No base rates yet.</Text>
            </Td>
          </Tr>
        )}
      </Tbody>
    </Table>
  );
}
